export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-back-WEB-Large-0024748d598ba68f397b6e4c8ab140f6.jpg";